import { useState } from 'react';
import { Container, Row, Col, Card, Badge, Nav, Button } from 'react-bootstrap';
import { motion } from 'motion/react';
import creativeData from '../../data/creativeData.json';

const Portfolio = () => {
  const [activeFilter, setActiveFilter] = useState('All Projects')

  const getImage = (imageName) => {
    return require(`../../assets/${imageName}`)
  }

  const { portfolio } = creativeData

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  }

  const cardVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5, ease: "easeOut" }
    }
  }

  return (
    <section className="portfolio-section section-lg bg-white">
      <Container>
        <div className="service-heading mb-3">
          <motion.h6 className="underline-after text-center position-relative z-0"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <span className="position-relative z-1 bg-white text-primary px-3">OUR WORK</span>
          </motion.h6>
          <motion.h2 className="d-block text-gradiant text-center fw-semibold display-5"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            Creative Portfolio Showcase
          </motion.h2>    
        </div>

        <Row className="mb-5">
          <Col xs={12}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
            >
              <Nav variant="pills" className="justify-content-center gap-2 flex-wrap">
                {portfolio.filters.map((filter) => (
                  <Nav.Item key={filter}>
                    <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                      <Nav.Link className={`px-4 py-2 rounded-pill fw-semibold ${activeFilter === filter ? 'active' : ''}`} onClick={() => setActiveFilter(filter)}>
                        {filter}
                      </Nav.Link>
                    </motion.div>
                  </Nav.Item>
                ))}
              </Nav>
            </motion.div>
          </Col>
        </Row>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.1 }}
        >
          <Row className="g-4 mb-5">
            {portfolio.projects.map((project) => (
              <Col xs={12} sm={6} lg={4} key={project.id}>
                <motion.div variants={cardVariants} whileHover={{ y: -10, transition: { duration: 0.3 } }}>
                  <Card className="border-0 shadow-lg rounded-4 overflow-hidden h-100 portfolio-card">
                    <motion.div className="portfolio-img position-relative overflow-hidden ratio ratio-4x3"
                      whileHover={{ scale: 1.05 }}
                      transition={{ duration: 0.3 }}
                    >
                      <Card.Img variant="top" src={getImage(project.image)} className="object-fit-cover w-100 h-100" alt={project.title} />
                    </motion.div>
                    <Card.Body className="p-4">
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <Card.Title className="fw-bold mb-0">{project.title}</Card.Title>
                        <Badge bg={project.badge.variant}>{project.badge.text}</Badge>
                      </div>
                      <Card.Text className="text-muted mb-3">{project.description}</Card.Text>
                      <div className="d-flex flex-wrap gap-2 mb-3">
                        {project.tags.map((tag, idx) => (
                          <motion.div key={idx} whileHover={{ scale: 1.1 }}>
                            <Badge bg="primary" pill>{tag}</Badge>
                          </motion.div>
                        ))}
                      </div>
                      <div className="d-flex align-items-center text-muted small">
                        <i className="ri-time-line me-2"></i>
                        <span>{project.duration}</span>
                        <span className="mx-2">•</span>
                        <i className="ri-team-line me-2"></i>
                        <span>{project.team}</span>
                      </div>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </motion.div>

        <Row>
          <Col xs={12} className="text-center">
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <Button variant="primary" size="lg" className="px-5 py-3 rounded-pill shadow-lg" href="#">
                <span className="me-2">View All Projects</span>
                <i className="ri-arrow-right-line"></i>
              </Button>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Portfolio;
